import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './auth-layout/forgot-password/forgot-password.component';
import { LoginComponent } from './auth-layout/login/login.component';
import { RequestPasswordSuccessComponent } from './auth-layout/request-password-success/request-password-success.component';
import { ResetPasswordSuccessComponent } from './auth-layout/reset-password-success/reset-password-success.component';
import { ResetPasswordComponent } from './auth-layout/reset-password/reset-password.component';
import { SendCandidatesEmailComponent } from './candidates-layout/send-candidates-email/send-candidates-email.component';
import { SendCandidatesSmsComponent } from './candidates-layout/send-candidates-sms/send-candidates-sms.component';
import { UploadCandidatePassportComponent } from './candidates-layout/upload-candidate-passport/upload-candidate-passport.component';
import { ViewCandidateComponent } from './candidates-layout/view-candidate/view-candidate.component';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CreateExaminationComponent } from './exam-layout/create-examination/create-examination.component';
import { EssayExamLogComponent } from './exam-layout/essay-exam-log/essay-exam-log.component';
import { ExamPenaltyComponent } from './exam-layout/exam-penalty/exam-penalty.component';
import { ExaminationCandidatesComponent } from './exam-layout/examination-candidates/examination-candidates.component';
import { ExaminationPortalApiParametersComponent } from './exam-layout/examination-portal-api-parameters/examination-portal-api-parameters.component';
import { ExaminationScriptComponent } from './exam-layout/examination-script/examination-script.component';
import { ExaminationSubjectsComponent } from './exam-layout/examination-subjects/examination-subjects.component';
import { ExaminationVenuesComponent } from './exam-layout/examination-venues/examination-venues.component';
import { ExaminationsComponent } from './exam-layout/examinations/examinations.component';
import { ExtraFieldsLabelComponent } from './exam-layout/extra-fields-label/extra-fields-label.component';
import { CreateQuestionsComponent } from './exam-layout/operations/create-questions/create-questions.component';
import { ExamCategoryComponent } from './exam-layout/operations/exam-category/exam-category.component';
import { ExamQuestionsComponent } from './exam-layout/operations/exam-questions/exam-questions.component';
import { QuestionBankComponent } from './exam-layout/question-bank/question-bank.component';
import { ExamScheduleAddedTimeLogComponent } from './examschedule-layout/exam-schedule-added-time-log/exam-schedule-added-time-log.component';
import { ExamScheduleBackupsComponent } from './examschedule-layout/exam-schedule-backups/exam-schedule-backups.component';
import { ExamScheduleEssayQuestionsComponent } from './examschedule-layout/exam-schedule-essay-questions/exam-schedule-essay-questions.component';
import { ExamScheduleFlagsComponent } from './examschedule-layout/exam-schedule-flags/exam-schedule-flags.component';
import { ExamSchedulePausedTimeLogComponent } from './examschedule-layout/exam-schedule-paused-time-log/exam-schedule-paused-time-log.component';
import { ExamScheduleQuestionsComponent } from './examschedule-layout/exam-schedule-questions/exam-schedule-questions.component';
import { ExaminationscheduleUnitsConfigComponent } from './examschedule-layout/examinationschedule-units-config/examinationschedule-units-config.component';
import { ExaminationscheduleComponent } from './examschedule-layout/examinationschedule/examinationschedule.component';
import { ExpectedScheduleComponent } from './examschedule-layout/expected-schedule/expected-schedule.component';
import { TimePeriodsComponent } from './misc-layout/time-periods/time-periods.component';
import { CbtPortalParameterComponent } from './parameter-layout/cbt-portal-parameter/cbt-portal-parameter.component';
import { WebtestParametersComponent } from './parameter-layout/webtest-parameters/webtest-parameters.component';
import { ProctorServerConfigComponent } from './proctor-layout/proctor-server-config/proctor-server-config.component';
import { ProctorsComponent } from './proctor-layout/proctors/proctors.component';
import { AuthguardService } from './services/http-services/authguard.service';
import { AddunitsComponent } from './units-layout/addunits/addunits.component';
import { BuyunitsComponent } from './units-layout/buyunits/buyunits.component';
import { UnitsPriceConfigComponent } from './units-layout/units-price-config/units-price-config.component';
import { VerifyPaymentComponent } from './units-layout/verify-payment/verify-payment.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { ComplaintsComponent } from './complaint-layout/complaints/complaints.component';
import { ViewComplaintComponent } from './complaint-layout/view-complaint/view-complaint.component';
import { EmailMessagesComponent } from './messages/email-messages/email-messages.component';
import { SmsMessagesComponent } from './messages/sms-messages/sms-messages.component';
import { MarkEssayComponent } from './exam-layout/operations/mark-essay/mark-essay.component';
import { MarkSaqComponent } from './exam-layout/operations/mark-saq/mark-saq.component';
import { ComplaintCategoryComponent } from './complaint-layout/complaint-category/complaint-category.component';
import { QuestionCategoriesComponent } from './exam-layout/operations/question-categories/question-categories.component';
import { VeiwScheduleComponent } from './examschedule-layout/veiw-schedule/veiw-schedule.component';
import { ExamExaminersComponent } from './exam-layout/operations/exam-examiners/exam-examiners.component';
import { PasswordUpdateComponent } from './auth-layout/password-update/password-update.component';
import { ExamSaqAnswersUpdateComponent } from './exam-layout/operations/exam-saq-answers-update/exam-saq-answers-update.component';
import { ProcteesComponent } from './monitoring/proctees/proctees.component';
import { VideosComponent } from './recordings/videos/videos.component';
//import { ExamvideoplayerComponent } from './recordings/examvideoplayer/examvideoplayer.component';
//import { VideodownloadComponent } from './recordings/videodownload/videodownload.component';
import { ProcteeflagsComponent } from './recordings/procteeflags/procteeflags.component';
import { ExaminationGroupComponent } from './exam-layout/examination-group/examination-group.component';
import { CompanySettingsComponent } from './company-settings/company-settings.component';
import { CandidateSebLockoutsComponent } from './candidates-layout/operations/candidate-seb-lockouts/candidate-seb-lockouts.component';
import { ViewExamScriptComponent } from './exam-layout/operations/view-exam-script/view-exam-script.component';
import { ExamQuestionAnalysisComponent } from './exam-layout/operations/exam-question-analysis/exam-question-analysis.component';
import { ImportPasswordsComponent } from './candidates-layout/import-passwords/import-passwords.component';
import { QuestionsBankComponent } from './questions-bank/questions-bank.component';
import { CreateUpdateQuestionComponent } from './questions-bank/create-update-question/create-update-question.component';
import { CreateUpdateQuestionBankComponent } from './questions-bank/create-update-question-bank/create-update-question-bank.component';
import { QuestionsComponent } from './questions-bank/questions/questions.component';
import { ExaminationQuestionBanksComponent } from './exam-layout/operations/examination-question-banks/examination-question-banks.component';
import { TemplateDownloadComponent } from './exam-layout/operations/template-download/template-download.component';
import { DownloadTemplatesComponent } from './template/download-templates/download-templates.component';
import { ChangeExamScheduleStartDateTimeComponent } from './examschedule-layout/change-exam-schedule-start-date-time/change-exam-schedule-start-date-time.component';
import { PsychometricReportComponent } from './exam-layout/operations/psychometric-report/psychometric-report.component';
import { QuestionGroupComponent } from './exam-layout/question-group/question-group.component';
import { QuestionsBankGroupComponent } from './questions-bank/questions-bank-group/questions-bank-group.component';
import { UploadCandidatesComponent } from './candidates-layout/upload-candidates/upload-candidates.component';
import { UsersComponent } from './users-layout/users/users.component';
import { CreateUserComponent } from './users-layout/create-user/create-user.component';

const routes: Routes = [
  {
    path: '',
    component: CustomLayoutComponent, canActivateChild: [AuthguardService], canActivate: [AuthguardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        title: 'Dashboard'
      },
      {
        path: 'exams',
        title: 'Examinations',
        children: [
          { path: '', component: ExaminationsComponent, title: 'Examinations' },
          { path: 'email-messages', component: EmailMessagesComponent, title: 'Email Messages' },
          { path: 'examiners', component: ExamExaminersComponent, title: 'Examination Examiners' },
          {
            path: ':examid/schedules',
            title: 'Examination Schedules',
            children: [
              { path: '', component: ExaminationscheduleComponent, title: 'Examination Schedule' },
              { path: ':examschid', component: VeiwScheduleComponent, title: 'View Examination Schedule' },
              { path: ':examschid/questions', component: ExamScheduleQuestionsComponent, title: 'Scheduled Exam Questions' },
              { path: ':examschid/eassayanswers', component: ExamScheduleEssayQuestionsComponent, title: 'Essay Answers' },
              { path: ':examschid/backups', component: ExamScheduleBackupsComponent, title: 'Exam Schedule Backups' },
              { path: ':examschid/addedtimelog', component: ExamScheduleAddedTimeLogComponent, title: 'Added Time Log' },
              { path: ':examschid/pausedtimelog', component: ExamSchedulePausedTimeLogComponent, title: 'Paused Time Log' },
              { path: ':examschid/flags', component: ExamScheduleFlagsComponent, title: 'Exam Schedule Flags' },
              { path: ':examschid/changeexamscheduledtartdatetime', component: ChangeExamScheduleStartDateTimeComponent, title: 'Change Exam Schedule Start Date/Time' },
              { path: 'report/:examschid/view-script', component: ViewExamScriptComponent, title: 'View Exam Script' },
              { path: 'report/:examschid/psychometric-report', component: PsychometricReportComponent, title: 'Psychometric Report' },
            ]
          },
          { path: ':examid/questions', component: ExamQuestionsComponent, title: 'Exam Questions' },
          { path: ':examid/category', component: ExamCategoryComponent, title: 'Exam Category' },
          { path: ':examid/proctors', component: ProctorsComponent, title: 'Exam Proctors' },
          { path: ':examid/recordings', component: VideosComponent, title: 'Exam Recordings' },
          { path: ':examid/flags', component: ProcteeflagsComponent, title: 'Proctee Flags' },
          { path: ':examid/essayexamlog', component: EssayExamLogComponent, title: 'Essay Exam Log' },
          { path: ':examid/markessay', component: MarkEssayComponent, title: 'Mark Essay Questions' },
          { path: ':examid/marksaq', component: MarkSaqComponent, title: 'Mark Short Answer Questions' },
          { path: ':examid/extrafields', component: ExtraFieldsLabelComponent, title: 'Extra Fields' },
          { path: ':examschid/exampenalties', component: ExamPenaltyComponent, title: 'Exam Penalties' },
          { path: ':examid/updatesaqanswers', component: ExamSaqAnswersUpdateComponent, title: 'Update SAQ Answers' },
          { path: ':examid/view-script', component: ViewExamScriptComponent, title: 'View Exam Script' },
          { path: ':examid/question-analysis', component: ExamQuestionAnalysisComponent, title: 'Exam Question Analysis' },
          { path: ':examid/questionbanks', component: ExaminationQuestionBanksComponent },
          { path: ':examid/psychometric-report', component: PsychometricReportComponent, title: 'Psychometric Report' },
          { path: ':examid/questiongroups', component: QuestionGroupComponent, title: 'Question Groups'},
        ]
      },
      { path: 'create_examination/:examid', component: CreateExaminationComponent, title: 'Create Examination' },

      {
        path: 'exam-groups',
        component: ExaminationGroupComponent,
        title: 'Examination Groups'
      },
      {
        path: 'questioncategory',
        component: QuestionCategoriesComponent,
        title: 'Question Categories'
      },
      
      {
        path: 'questions-bank', title: 'Question Bank',
        children: [
          { path: 'create', component: CreateUpdateQuestionBankComponent, title: ' Create Question Bank' },
          { path: ':questionBankID/update', component: CreateUpdateQuestionBankComponent, title: 'Update Question Bank' },
          { path: '', component: QuestionsBankComponent, title: 'Question Banks' },
          { path: ':questionBankID/questions', component: QuestionsComponent, title: 'Question Bank Questions' },
          { path: ':questionBankID/questions/create', component: CreateUpdateQuestionComponent, title: 'Create Question Bank Question' },
          { path: ':questionBankID/questions/:questionid/update', component: CreateUpdateQuestionComponent, title: 'Update Question Bank Question' },
          { path: ':questionBankID/questiongroups', component: QuestionsBankGroupComponent, title: 'Question Bank Groups' },

        ]
      },
      { path: 'passport', component: UploadCandidatePassportComponent, title: 'Upload Candidate Passport' },
      { path: 'upload-candidates', component: UploadCandidatesComponent, title: 'Upload Candidates' },
      {
        path: 'candidates',
        title: 'Candidates',
        children: [
          { path: '', component: ExaminationCandidatesComponent, title: 'Examination Candidates' },
          { path: 'view', component: ViewCandidateComponent, title: 'Candidate Details' },
          { path: ':examno/seb-lockouts', component: CandidateSebLockoutsComponent, title: 'Candidate SEB Lockouts' }
        ]
      },
      {
        path: 'complaints',
        title: 'Tickets',
        children: [
          { path: '', component: ComplaintsComponent, title: 'Ticket' },
          { path: 'exam/:examid', component: ComplaintsComponent, title: 'Exam Tickets' },
          { path: 'examsch/:examschid', component: ComplaintsComponent, title: 'Exam Schedule Tickets' },
          { path: 'view', component: ViewComplaintComponent, title: 'View Ticket' },
        ]
      },
      { path: 'complaint-category', component: ComplaintCategoryComponent, title: 'Ticket Category' },
      {
        path: 'questions',
        title: 'Questions',
        children: [
          { path: '', component: ExamQuestionsComponent, title: 'Questions' },
          { path: ':questionid', component: CreateQuestionsComponent, title: 'Create or Edit Question' },
        ]
      },
      {
        path: 'users',
        title: 'Users',
        children: [
          { path: '', component: UsersComponent, title: 'Users' },
        ]
      },
      { path: 'create_user/:id', component: CreateUserComponent, title: 'Create User' },

      {
        path: 'buyunits',
        component: BuyunitsComponent,
        title: 'Buy Units'
      },
      // {
      //   path: 'faq',
      //   component: BuyunitsComponent,
      //   title: 'Frequently Asked Questions'
      // },
      // {
      //   path: 'contact',
      //   component: BuyunitsComponent,
      //   title: 'Contact Us'
      // },
      {
        path: 'tempalates-download',
        component: DownloadTemplatesComponent,
        title: 'Download Templates'
      },
      {
        path: 'company-settings',
        component: CompanySettingsComponent,
        title: 'Company Settings'
      }
    ],
  },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: UserRegistrationComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  { path: 'resetpassword', component: ResetPasswordComponent },
  { path: 'resetpasswordsent', component: RequestPasswordSuccessComponent },
  { path: 'passwordresetsuccess', component: ResetPasswordSuccessComponent },
  { path: 'update-password', component: PasswordUpdateComponent },
  { path: 'verify', component: VerifyPaymentComponent },
  // { path: 'examvideoplayer', component: ExamvideoplayerComponent },
  // { path: 'download', component: VideodownloadComponent },
  { path: 'monitor', component: ProcteesComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
